import Axios from '@/plugins/Axios';
import { MidtransConfig } from '@/types';
import { AxiosResponse } from 'axios';

const endpoint = '/config';

const configApi = {
  getConfigMidtrans: () => {
    return Axios().get<MidtransConfig>(`${endpoint}`);
  },
};

export default configApi;
